<script lang="ts">
    import type { MealyExecutionState } from "../../state/executionState";
    import type { MachineStateMealy_Kunstautomat1 } from "../../state/machineState";
    import KunstautomatSystemBase from "./KunstautomatSystemBase.svelte";

    export let machineState: MachineStateMealy_Kunstautomat1;
    export let mealyExecutionState: MealyExecutionState;
    export let isExecuting: boolean;
</script>

<KunstautomatSystemBase 
    machineState={machineState}
    mealyExecutionState={mealyExecutionState}
    isExecuting={isExecuting}
    show2Euro={false}
/>
